import { HtmlDocType } from "./htmlDocType";
import { HtmlDocumentVersion } from "./htmlDocumentVersion";

export class HtmlDocument {

  constructor(
    private id: number, 
    private documentType: HtmlDocType, 
    private versionCount: number
  ) {}

  getId(): number { return this.id; }
  getDocumentType(): HtmlDocType { return this.documentType; }
  getVersionCount(): number { return this.versionCount; }

  static fromJson(json: any): HtmlDocument {
    return new HtmlDocument(json.id, json.documentType, json.versionCount);
  }
}